import React from 'react'
import {Link} from '../../../components/link'
import {Box} from '../../../vanilla'

export const LetUsKnow = () => {
  return (
    <Box paddingTop="28px" paddingBottom="20px" gridColumn="span 12">
      <Link href="https://iceland.eu.research.net/r/3RBL9G2">
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet="//assets.iceland.co.uk/i/iceland/ECOM_CD-9298_BookASlot_Survey_PLBanner_DESK_V2"
            style={{width: '100%'}}
          />
          <img
            src="//assets.iceland.co.uk/i/iceland/ECOM_CD-9298_BookASlot_Survey_PLBanner_MOB_V2"
            alt="Delivery Survey"
            style={{width: '100%'}}
          />
        </picture>
      </Link>
    </Box>
  )
}
